import React from "react";
import omit from "@/utils/omit";
import { IconProps } from "../interface";

const IconAdOpenArrow = React.forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      className="yfm-icon yfm-icon-ad-open-arrow"
      {...omit(props, ["className"])}
    >
      <g clipPath="url(#clip0_2293_631)">
        <path
          d="M7.09707 12C7.2377 12 7.36895 11.9437 7.4627 11.85C7.55645 11.7562 7.6127 11.625 7.6127 11.4844C7.6127 11.3437 7.55645 11.2125 7.4627 11.1187L2.4002 6.06563L7.59395 0.881251C7.8002 0.675001 7.8002 0.346876 7.59394 0.15C7.50019 0.0562503 7.36895 6.81981e-07 7.22832 6.88128e-07C7.08769 6.94275e-07 6.95645 0.0562503 6.8627 0.15L1.30332 5.7C1.20019 5.80313 1.15332 5.93438 1.15332 6.06563C1.15332 6.19688 1.2002 6.32813 1.30332 6.43125L6.73145 11.85C6.83457 11.9437 6.95645 12 7.09707 12Z"
          fill="white"
        />
        <path
          d="M10.1908 12C10.3314 12 10.4627 11.9437 10.5564 11.85C10.6502 11.7562 10.7064 11.625 10.7064 11.4844C10.7064 11.3437 10.6502 11.2125 10.5564 11.1187L5.49395 6.06563L10.6877 0.881251C10.8939 0.675001 10.8939 0.346876 10.6877 0.15C10.5939 0.0562503 10.4627 6.81981e-07 10.3221 6.88128e-07C10.1814 6.94275e-07 10.0502 0.0562503 9.95645 0.15L4.39707 5.7C4.29395 5.80313 4.24707 5.93438 4.24707 6.06563C4.24707 6.19688 4.29395 6.32813 4.39707 6.43125L9.8252 11.85C9.92832 11.9437 10.0502 12 10.1908 12Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2293_631">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(0 12) rotate(-90)"
          />
        </clipPath>
      </defs>
    </svg>
  )
);

IconAdOpenArrow.displayName = "IconAdOpenArrow";

export default IconAdOpenArrow;
